import type { MaybeRef } from 'vue'
import type { Maybe } from '@/types'
import type {
  CustomerProduct,
  CustomerProductListItem,
} from '@/types/customer/products'

import { computed, unref } from 'vue'
/**
 * До тех пор, пока в товаре приходят только скидки самого товара (type: "product"),
 * все ок (функция только для витрины)
 * */
export const useProductPrices = (
  product: MaybeRef<
    Maybe<CustomerProductListItem | CustomerProduct> | undefined
  >
) => {
  const discount = computed(() => unref(product)?.discounts?.[0])
  const hasDiscount = computed(() => !!discount.value?.amount)

  const price = computed(() => unref(product)?.price ?? 0)

  const discountedPrice = computed(() => {
    const amount = discount.value?.amount ?? 0
    if (!amount) return price.value

    if (discount.value?.absolute) return price.value - amount

    return price.value - price.value * (amount / 100)
  })

  return {
    price,
    discount,
    hasDiscount,
    discountedPrice,
  }
}
